<template>
    <div class="index notranslate">
        <!-- appbar -->
        <v-header :is-seft="0"></v-header>

        <!-- cart content -->
        <mu-container class="content" style="padding-left:0px;padding-right:0px;overflow-y:auto;padding-bottom:60px;" v-show="!showOrderTip">
            <mu-form class="mu-demo-form" :model="order" label-width="100" labelPosition="left" style="padding: 20px;">
                        <mu-form-item :label="$t('orderList.orderNo')" class="form-confirm-item" style="color: #DA5B3A !important;font-size: 22px !important;font-weight: 900 !important;">
                            <div class="form-confirm-txt">{{order.orderNo}}</div>
                        </mu-form-item>
                        <mu-form-item  :label="$t('orderList.name')" class="form-confirm-item">
                            <div class="form-confirm-txt">{{order.customerName}}</div>
                        </mu-form-item>
                        <mu-form-item  :label="$t('orderList.telephone')"  class="form-confirm-item">
                            <div class="form-confirm-txt">{{order.telephone}}</div>
                        </mu-form-item>
                        <mu-form-item  :label="$t('orderList.deliveryType')"  class="form-confirm-item">
                            <div class="form-confirm-txt" v-if="order.deliveryType==1">{{$t('orderList.pickUp')}}</div>
                            <div class="form-confirm-txt" v-if="order.deliveryType==2"> {{$t('orderList.delivered')}}</div>
                        </mu-form-item>
                        <mu-form-item  :label="$t('orderList.orderTime')"  class="form-confirm-item">
                            <div class="form-confirm-txt">{{order.orderDay}}</div>
                        </mu-form-item>
                        <mu-form-item  :label="$t('orderList.address')" v-if="order.deliveryType==2"  class="form-confirm-item">
                            <div class="form-confirm-txt">
                                <div> {{order.postNummer}}  {{order.postBy}}</div>   
                                <div> {{order.address}}</div>   
                            </div>
                        </mu-form-item>
                        <mu-form-item  :label="$t('orderList.number')"  class="form-confirm-item">
                            <div class="form-confirm-txt">{{$t('orderList.adult')}}:{{order.adult}}   {{ $t('orderList.children') }}:{{order.children==null?0:order.children}}</div>
                        </mu-form-item>
                        <mu-form-item  :label="$t('orderList.specielle')"  class="form-confirm-item" v-if="order.specielle!=null&&order.specielle!=''">
                            <div class="form-confirm-txt">{{order.specielle}} </div>
                        </mu-form-item>
                    </mu-form>
            <div class="cart-box" style="margin-top:5px;" v-for="(val, key, index) in cartShowData" :key="index">
                <mu-list>
                    <mu-list-item style="height:36px;" v-if="key!='null'">
                        <mu-list-item-content>
                            <mu-list-item-title class="table-info-list-title">{{key.replace(/\"/g,"")}}</mu-list-item-title>
                        </mu-list-item-content>
                    </mu-list-item>
                    <mu-divider shallow-inset v-if="key!='null'"></mu-divider>
                    <mu-list-item style="height:40px;margin:20px auto;" v-for="item,index in val" :key="index">
                        <mu-flex>
                            <mu-avatar style="width: 60px !important;">
                                <img :src="getImgUrl(item.foodImage,200)" style="border-radius:0;">
                            </mu-avatar>
                        </mu-flex>
                        <mu-list-item-content>
                            <div style="margin-left: 5px;">
                                <div style="float:left;">
                                    <div style="font-size:12px;height:24px;line-height:24px;">
                                        {{item.foodName}} 
                                        <van-tag plain type="danger" v-if="item.state==1">Delete</van-tag>
                                        <van-tag plain type="warning" v-if="item.state==2">Return</van-tag>
                                    </div>
                                    <div style="font-size:12px;" v-if="item.decideName!=null && item.decideName!=''">
                                        {{item.decideName}}
                                    </div>
                                    <div>
                                        <span class="now">{{ item.price }} {{seller.unit}}</span>
                                        <span>x {{ item.quantity }}</span>
                                    </div>
                                </div>
                                <div class="cart-opration" style="float:right;">
                                    <span class="now"> {{item.quantity * item.price}} {{seller.unit}}</span>
                                </div>
                            </div>
                        </mu-list-item-content>
                    </mu-list-item>
                </mu-list>
            </div>

                <div style="height:100px;text-align:right;padding-top: 20px;padding-right: 20px;" >
                    <div style="font-size:14px;width: 100%;" v-if="tableOrderInfo.deliveryType==2">
                        {{$t('orderList.subAmount')}}:<span style="color:#f01414;font-weight:600;"> {{order.orderAmount}} {{seller.unit}}</span>
                    </div><br>
                    <div style="font-size:14px;width: 100%;" v-if="tableOrderInfo.deliveryType==2">
                        {{$t('orderList.postAmount')}}:<span style="color:#f01414;font-weight:600;"> {{order.postAmount}} {{seller.unit}}</span>
                    </div><br>
                    <div style="font-size:18px;width: 100%;">
                        {{$t('orderList.total')}}:<span style="color:#f01414;font-weight:600;"> {{order.actualAmount}} {{seller.unit}}</span>
                   
                    </div>
                </div>
 

            <div class="oprations">


                <div class="oprations-btn">
                    <div class="oprations-next enough" @click="jumpHome">{{$t('orderList.home')}}</div>
                </div>
            </div>

        </mu-container>
        <div style="width: 100%; background: #fff; padding: 20px;text-align:center;padding-top:60px;" v-show="showOrderTip">
            <mu-flex class="flex-wrapper" justify-content="center">
                <div style="font-size:16px;font-weight:600;color:#DA5B3A;">{{$t('buffet.nullOrder')}}</div>
            </mu-flex>
            <mu-flex class="flex-wrapper" justify-content="center">
                <div style="width: 100%; text-align: center; margin-top: 30px;"><mu-button color="success" @click="jumpBack" style="text-transform:unset;">{{$t('orderList.return')}}</mu-button></div>
            </mu-flex>
        </div>

    </div>

    
</template>
<script>
    import header from '../components/TakeawayHeader';
    export default {
        name: 'TakeawayOrderList',
        data() {
            return {
                title: 'Order bill',
                seller: {},
                showFullScreen: true,
                tableOrderInfo: {},
                total:0,
                cartList: [],
                groupCartList: [],
                groupCartBuffetList: [],
                cartShowData: {},
                cartBuffetShowData: {},
                showOrderTip: false,
                isSeft: 0,
                docked: false,
                open: false,
                current: -1,
                cartOwerData: {},
                openOrderChange: false,
                timer: null,
                orderNo:0,
                order:{}
            }
        },
        components: {
            'v-header': header
        },
        mounted() {
            this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
            this.isSeft = 0;
            if(this.$route.query.orderId!=undefined && this.$route.query.orderId!=null){
                this.getOrderMainByOrderId(this.$route.query.orderId);
            }
            if (this.timer != null) {
                clearInterval(this.timer);
            }

        },
        methods: {
            jumpOrderChange() {
                this.openOrderChange = false;
                this.$router.push({
                    path: '/result'
                })
            },
            jumpHome() {
                this.$router.push({ path: '/takeaway' });
            },
            getOrderMainByOrderId(orderId){
                let param = {
                    orderId: orderId,
                };
                this.$get('QRCodeOrder/GetOrderMain', param)
                    .then(response => {
                        if (response.code == 200) {
                            var data = response.data;
                            this.order=data;
                            if (data == null || data == '') {
                                this.showOrderTip = true;
                                return;
                            }
                            this.getOrderList(data.orderId);
                        }
                    });
            },
            getOrderMain(){
                let param = {
                    restaurantId: this.tableOrderInfo.restaurantId,
                    tableName: this.tableOrderInfo.tableName,
                    telephone: this.tableOrderInfo.telephone
                };
                this.$get('QRCodeOrder/GetUnpayOrderMainByTelephone', param)
                    .then(response => {
                        if (response.code == 200) {
                            var data = response.data;
                            this.order=data;
                            if (data == null || data == '') {
                                this.showOrderTip = true;
                                return;
                            }
                            this.getOrderList(data.orderId);
                        }
                    });
            },
            getOrderList(orderId) {
                this.total = 0;
                this.$get('QRCodeOrder/GetQRcodeTakeAwayOrderList', {
                    orderId: orderId
                }).then(result => {
                    if (result.code == 200) {
                        this.cartList = result.data;
                        if (this.cartList.length == 0) {
                            this.cartShowData = [];
                            this.showOrderTip = true;
                            return;
                        }
                        this.total = 0;
                        this.showOrderTip = false;
                        for (var i = 0; i < this.cartList.length; i++) {
                            this.total += (this.cartList[i].quantity * this.cartList[i].price);
                        }
                        this.cartShowData = this.groupBy(this.cartList, (cart) => {
                            return cart.foodTypeName
                        });
                    }
                    else {
                        this.showOrderTip = true;
                    }
                });
            },
            groupBy(list, fn) {
                const groups = {};
                list.forEach(function (o) {
                    const group = JSON.stringify(fn(o));
                    groups[group] = groups[group] || [];
                    groups[group].push(o);
                });
                return groups;
            },
            getImgUrl(image,w=0) {
                if (image == undefined || image == 'undefined' || image == null|| image == '') {
                    return '../static/img/default.png';
                }
                if(w==0){
                    return this.global.baseUrl + "uploads/" + image
                }
                return  this.global.baseUrl+"api/images/"+w+"/"+ image
            },
            refresh() {
                this.getOrderList();
                this.$toast.success('Refresh successfully!');
            },
            jumpIndex() {
                if (this.timeOutCheck()) {
                    this.$router.push({ path: '/takeaway' });
                }
            },
            timeOutCheck() {
                let that = this;
                var time = window.localStorage.getItem('timeOut');
                if (time != undefined && time != null && time != "") {
                    var dateTimeStamp = new Date(time.replace(/-/g, '/')).getTime();
                    var now = new Date().getTime();
                    var diffValue = now - dateTimeStamp;
                    var minute = 1000 * 60;
                    var minC = diffValue / minute;
                    if (parseInt(minC) >= 120) {
                        this.$alert(this.$t("common.pageInvalid"), this.$t("common.alert"), {
                            type: 'warning', okLabel: this.$t("common.ok"),
                        }).then(function (result, value) {
                            that.$router.push({
                                path: '/error'
                            })
                        });
                        return false;
                    }
                    return true;
                }
                this.$alert(this.$t("common.pageInvalid"), this.$t("common.alert"), {
                    type: 'warning', okLabel: this.$t("common.ok"),
                }).then(function (result, value) {
                    that.$router.push({
                        path: '/error'
                    })
                });
                return false;
            },
            jumpBack() {
                if (this.timeOutCheck()) {
                    this.$router.push({ path: '/takeaway' });
                }
            },
            getPath() {
                if (this.$route.path == '/takeawayOrderList') {
                    if(this.$route.query.orderId!=undefined && this.$route.query.orderId!=null){
                        this.getOrderMainByOrderId(this.$route.query.orderId);
                 }
                }
            },
            openDrawer() {
                this.open = !this.open;
                this.docked = false;
            },
        },
         watch: {
           '$route': 'getPath'
        },
    }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
    .nav-title {
        text-align: center;
        font-size:18px;
    }
    .mu-list {
        padding: 5px 0;
    }
    .mu-button {
        text-transform:unset;
    }
    .mu-button .mu-icon-left {
        margin-right: 3px;
    }
    .mu-raised-button .mu-button-wrapper {
        padding: 0;
    }
    .material-icons {
        font-size: 16px;
    }
    .order-list-item {
        margin-bottom: 0px;
    }
    .content {
        width: 100%;
        height: 100%;
        position: absolute;
        padding-top:10px;
    }

    .cart-box {
        position: relative;
        margin: auto;
        background-color:#fff;
        background-size: cover;
        overflow-y:unset;
    }

    .table-info-keywords {
        color: #e53935;
        font-size: 18px;
        font-weight: 600;
        margin-left: 10px;
    }
    .table-info-list-title {
        text-align: center;
        font-size: 16px;
        color: #4fc3f7;
    }
    .cart-opration {
        float: right; 
    }

    .cart-opration-btn {
        width: 32px;
        height: 32px;
        min-width: unset;
        font-size: 16px;
        color: #e53935;
        padding:0px;
    }

    .cart-opration-quantity {
        width: 36px;
        height: 32px;
        min-width: unset;
        top: -3px;
    }
    .btn-refresh {
        position: fixed;
        right:10px;
        background-color: #757575 !important;
        z-index:10;
    }
    .btn-menu {
        position: fixed;
        bottom: 10px;
        left: 10px;
        background-color: #757575 !important;
    }
    .btn-continue {
        position: fixed;
        bottom: 10px;
        background-color: #757575 !important;
        left: 41%;
    }
    .btn-order {
        position: fixed;
        bottom: 10px;
        right: 10px
    }
    .now {
        font-size: 12px;
        color: #f01414;
        font-weight: 700;
        line-height: 24px;
        margin-right: 8px;
    }
    .old {
        font-size: 12px;
        text-decoration: line-through;
        color: #93999f;
        font-weight: 700;
        line-height: 24px;
    }
    .seal {
        max-width: 120px;
        margin: auto;
        -webkit-backface-visibility: hidden;
        float: left;
    }

    .stamp {
        position: relative;
    }
        .stamp:after {
            border: solid 0.1em #d00;
            border-radius: .2em;
            color: #d00;
            content: 'Order';
            font-size: 16px;
            font-weight: bold;
            line-height: 1;
            opacity: 0;
            position: absolute;
            padding: .1em .5em;
            margin: 0 auto;
            top: 2px;
            text-transform: uppercase;
            opacity: 0;
            transform-origin: 50% 50%;
            transform: rotate(-2deg) scale(5);
            transition: all 0.3s cubic-bezier(0.6, 0.04, 0.98, 0.335);
        }

    .loaded .stamp:after {
        opacity: .75;
        transform: rotate(-5deg) scale(1);
        z-index: 101;
    }
    .btn-home {
        position: fixed;
        bottom:10px;
        left: 10px;
        background-color: #da5b3a !important;
    }
    .close-icon {
        position: absolute;
        top: 10px;
        right: 10px;
    }
    .ower {
        position: relative;
        z-index: 9;
        padding: 10px;
        background-color: #fff;
    }

    .badge-num {
        float: left;
        width: 60px;
        height: 32px;
        margin-right: 5px;
        margin-bottom: 5px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 0 6px;
        line-height: 1.5;
        font-size: 14px;
        font-style: normal;
        background-color: #bdbdbd;
        color: #fff;
        border-radius: 3px;
        overflow: hidden;
    }

    .select {
        background-color: rgb(218, 91, 58);
    }

    .oprations {
        position: fixed;
        bottom: 0;
        right: 0;
    }

        .oprations .oprations-btn {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 105px;
            flex: 0 0 105px;
            width: 105px;
            float: left;
        }

            .oprations .oprations-btn .oprations-back {
                height: 48px;
                line-height: 48px;
                font-size: 12px;
                font-weight: 700;
                text-align: center;
                background-color: #bdbdbd;
                color: #fff;
                float: right;
                width: 100%;
            }

            .oprations .oprations-btn .oprations-next {
                height: 48px;
                line-height: 48px;
                font-size: 12px;
                font-weight: 700;
                text-align: center;
                float: right;
                width: 160px;
            }

                .oprations .oprations-btn .oprations-next.not-enough {
                    background: #bdbdbd;
                }

                .oprations .oprations-btn .oprations-next.enough {
                    background: #da5b3a;
                    color: #fff;
                }

                .form-confirm-item {
                    margin-bottom: 0 !important;
                    padding-bottom: 0 !important;
                }
                .form-confirm-txt{
                    line-height: 26px;
                }

                /deep/ .mu-form-item__label-left, .mu-form-item__label-right{
                    -webkit-box-orient: horizontal;
                    -webkit-box-direction: normal;
                    -ms-flex-direction: row;
                    flex-direction: row;
                    min-height: 22px;
                }
</style>



// WEBPACK FOOTER //
// src/components/TakeawayOrderList.vue